//https://codepen.io/erwinquita/pen/ZWzVRE
import React, { useState } from "react";
import DropdownMenu from "../Dropdownmenu";
import "./styles.css";

const Steplist = ({ userdata, currentSteps }) => {
	const [toggle, setToggle] = useState(false);

	const toggleState = () => {
		setToggle(!toggle);
	};
	console.log("currentSteps=", currentSteps);

	if (!userdata) {
		return <h3 className="loading">Loading...</h3>;
	}
	console.log("Toggle list userdata=", userdata);
	var listdata = userdata;
	const menuItems = [
		{
			label: "Delete",
			icon: "fa fa-trash-o",
			onClick: () => alert("Delete"),
		},
	];
	console.log("this.props.userdata=", userdata);
	console.log("steplist listdata=", listdata);
	var listItems = listdata.map((listdatatem) => (
		<li
			key={listdatatem.id}
			className={
				"StepProgress-item" +
				(currentSteps === listdatatem.id ? " current" : "") +
				(listdatatem.status > 0 ? " is-done" : "")
			}
		>
			<div className="row">
				<div className="col-sm-8">
					<strong>{listdatatem.name}</strong>
				</div>
				<div className="col-sm-4">
					{listdata[0].id === listdatatem.id && (
						<DropdownMenu items={menuItems} />
					)}
				</div>
			</div>
		</li>
	));

	return (
		<div className="wrapper">
			<ul className="StepProgress">
				{listItems}

				{/*<li className="StepProgress-item is-done">
						<strong>Post a contest</strong>
					</li>
					<li className="StepProgress-item is-done">
						<strong>Award an entry</strong>
						Got more entries that you love? Buy more entries anytime! Just hover
						on your favorite entry and click the Buy button
					</li>
					<li className="StepProgress-item current">
						<strong>Post a contest</strong>
					</li>
					<li className="StepProgress-item">
						<strong>Handover</strong>
					</li>
					<li className="StepProgress-item">
						<strong>Provide feedback</strong>
                    </li>
        */}
			</ul>
		</div>
	);
};
export default Steplist;
